import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-equivalent-dialog',
  templateUrl: './remove-equivalent-dialog.component.html',
  styleUrls: ['./remove-equivalent-dialog.component.scss']
})
export class RemoveEquivalentDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveEquivalentDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      articleOld: string,
      articleNew: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
